import { render, staticRenderFns } from "./SoundQuestion.vue?vue&type=template&id=701cdf6f&scoped=true&"
import script from "./SoundQuestion.vue?vue&type=script&lang=ts&"
export * from "./SoundQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./SoundQuestion.vue?vue&type=style&index=0&id=701cdf6f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701cdf6f",
  null
  
)

export default component.exports